define('lq/events/actions/asyncEventTrigger',[
    'lq/events/actions/eventAction'
], function(EventAction) {
    'use strict';
        
    function AsyncEventTrigger(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(AsyncEventTrigger, EventAction);

    AsyncEventTrigger.typeName = 'AsyncEventTrigger';

    AsyncEventTrigger.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };
        
    AsyncEventTrigger.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'AsyncEventTrigger',
            command: this.eventData.command
        };
    };

    return AsyncEventTrigger;
});
